import { theme } from 'theme'
import styled from 'particles/themes/styled'

export const ErrorPageContainer = styled.div`
    background-color: ${theme.newColors.neutral50};
    height: 100%;
    .body {
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
        max-width: 606px;
        margin: auto;
    }
    .title {
        padding-bottom: ${theme.newSpacing.xxs};
    }
    .subtitle {
        padding-bottom: ${theme.newSpacing.l};
    }
`
